import { Inject, Service } from 'vue-di-container';
import { GenerateVerificationResponse } from './Model/GenerateVerificationResponse';
import { GenerateVerificationRequestModel } from './Model/GenerateVerificationRequestModel';
import AxiosService from '@/services/AxiosService';
import LoaderService from '@/services/LoaderService';
import { BackEndUrlsEnum } from '@/shared/Enums/BackEndUrlsEnum';
import { OldOtpResponse } from '@/components/AttorneyRegistration/Preview/Model/OldOtpResponse';

@Service()
export default class FaskhVerificationService {
  @Inject(AxiosService) public axiosService!: AxiosService;
  @Inject(LoaderService) public loaderService!: LoaderService;


  public async generateVerification(
    generateVerificationRequest: GenerateVerificationRequestModel
  ): Promise<GenerateVerificationResponse> {
    this.loaderService.ShowLoader();
    const url = 'api/AnonymousUserVerification/GenerateVerification';

    const result = await this.axiosService.axiosInstance.post<
      GenerateVerificationResponse
    >(url, generateVerificationRequest);
    this.loaderService.HideLoader();
    return result.data;
  }

  public async oldIdentify(): Promise<GenerateVerificationResponse> {
    this.loaderService.ShowLoader();
    const result = await this.axiosService.axiosInstance.post<OldOtpResponse>(
      BackEndUrlsEnum.SendOldConfirmationOtp.toString()
    );
    this.loaderService.HideLoader();
 
    let res: GenerateVerificationResponse = {
      isSuccessful: result.data.isSuccessful,
      token: result.data.providerRefId,
      duration: 60
    } as GenerateVerificationResponse;
    return res;
  }


}
